"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    withIcon: {
        paddingLeft: '10px !important',
        '&::before': {
            display: 'none !important',
        },
    },
    notification: function (_a) {
        var color = _a.color, theme = _a.theme;
        return ({
            boxSizing: 'border-box',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 22,
            paddingRight: 5,
            paddingTop: 10,
            paddingBottom: 10,
            borderRadius: 4,
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.white,
            border: "1px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]),
            '&::before': {
                content: "''",
                display: 'block',
                position: 'absolute',
                width: 6,
                top: 4,
                bottom: 4,
                left: 4,
                borderRadius: 4,
                backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: 6 }),
            },
            '& $icon': {
                backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: 6 }),
                color: theme.white,
            },
        });
    },
    body: function (_a) {
        var disallowClose = _a.disallowClose;
        return ({
            flex: 1,
            maxWidth: !disallowClose ? 'calc(100% - 40px)' : '100%',
            marginRight: 10,
        });
    },
    loader: function (_a) {
        var theme = _a.theme;
        return ({
            marginRight: theme.spacing.md,
        });
    },
    icon: function (_a) {
        var theme = _a.theme;
        return ({
            boxSizing: 'border-box',
            marginRight: theme.spacing.md,
            width: 28,
            height: 28,
            borderRadius: 28,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: theme.white,
        });
    },
    title: function (_a) {
        var theme = _a.theme;
        return ({
            lineHeight: 1.4,
            marginBottom: 2,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: theme.colorScheme === 'dark' ? theme.white : theme.colors.gray[9],
        });
    },
    description: function (_a) {
        var theme = _a.theme;
        return ({
            color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[6],
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:only-child': {
                color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,
            },
        });
    },
}, { link: true });
